import type {
  CheckoutSubModeV3,
  PickupHandoffModeV3,
  SessionMetadataCheckoutMode,
  SessionMetadataCollect,
} from 'pi-kiosk-shared';
import { resolvePickupHandoffModeForCheckout } from 'pi-kiosk-shared';
import type { CheckoutSubMode } from './checkoutApi.js';

export { resolvePickupHandoffModeForCheckout };

export function buildCheckoutModeForCollectPatch(
  checkoutSubMode: CheckoutSubMode,
  commerceConfigJson?: Record<string, unknown> | null,
  pickupHandoffModeOverride?: PickupHandoffModeV3
): SessionMetadataCheckoutMode {
  return {
    channel: 'MOBILE_FIRST',
    selectedMode: checkoutSubMode as CheckoutSubModeV3,
    pickupHandoffMode:
      pickupHandoffModeOverride ??
      resolvePickupHandoffModeForCheckout(checkoutSubMode, commerceConfigJson),
  };
}

export function resolveLockedCollectTiming(
  checkoutSubMode: CheckoutSubMode
): SessionMetadataCollect['timing'] {
  if (checkoutSubMode === 'PREPAY_COLLECT_LATER') {
    return 'LATER';
  }
  return 'NOW';
}

export function filterLegacyCheckoutModes(modes: readonly string[]): CheckoutSubMode[] {
  const allowed = new Set<CheckoutSubMode>([
    'PAY_NOW_SELF_SERVICE',
    'PAY_NOW_STAFF_HANDOFF',
    'PREPAY_COLLECT_LATER',
  ]);
  return modes.filter((mode): mode is CheckoutSubMode => allowed.has(mode as CheckoutSubMode));
}
